<template>
  <article class="question">
    <div class="column">
      <p class="disclaimer">
        Please do not share any personal information, including any payment information, in the following field.
      </p>
      <p class="text">{{ question }}</p>
      <textarea
        v-bind="$attrs"
        autocomplete="off"
        v-on="$listeners"
        placeholder="Include further feedback.."
        :value="value"
        class="text-area"
        rows="5"
      ></textarea>
    </div>
  </article>
</template>

<script>
export default {
  props: ['value', 'question'],
};
</script>

<style scoped lang="scss">
@import './question.scss';

.text-area {
  font-family: var(--font-family);
  background: #f7f8f9;
  border: 1px solid #c8c9c7;
  box-sizing: border-box;
  border-radius: 5px;
  width: 100%;
  padding: 10px 15px;
}

.text-area::placeholder {
  font-family: var(--font-family);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #9b9d9f;
}
</style>
